import { cn } from "@/util/cn";
import { type VariantProps, cva } from "class-variance-authority";
import NextLink, { type LinkProps } from "next/link";
import type { ReactNode } from "react";

type Props<RouteType> = LinkProps<RouteType> & {
    children?: ReactNode;
    className?: string;
    target?: string;
} & VariantProps<typeof linkVariants>;

const linkVariants = cva("", {
    variants: {
        variant: {
            default: "text-foreground hover:text-accent-flashy active:text-purple",
            glow: "no-underline text-accent-flashy hover:underline active:text-purple",
        },
    },
    defaultVariants: {
        variant: "default",
    },
});

export function Link<RouteType>({ children, className, variant, ...props }: Props<RouteType>) {
    return (
        <NextLink className={cn(linkVariants({ className, variant }))} {...props}>
            {children}
        </NextLink>
    );
}
